<template>
  <aside class="gp-map-popup" @mouseover="$emit('mouse-over')" @mouseleave="$emit('mouse-leave')">
    <div class="gp-map-popup__header">
      <h3 class="-text--default-size">{{ caption }}</h3>
      <!-- eslint-disable vue/no-v-html -->
      <small v-if="surface" v-html="surface" />
      <!-- eslint-enable vue/no-v-html -->

      <!--
        Handler should close the popup
        @event close
      -->
      <rui-button class="gp-map-popup__closer"
                  icon="x-bold"
                  size="small"
                  text
                  @click="$emit('close')" />
    </div>
    <div v-if="!isDefaultSlotEmpty || help || $slots.help" class="gp-map-popup__actions">
      <rui-toolbar>
        <!-- @slot Default slot for action buttons -->
        <slot />
        <template v-if="help || $slots.help" #right>
          <rui-help-button :content="help">
            <!-- @slot Optional help -->
            <slot name="help" />
          </rui-help-button>
        </template>
      </rui-toolbar>
    </div>
  </aside>
</template>

<script>
import RuiButton from '@experiments-labs/rise_ui/src/components/Button/Button.vue'
import RuiHelpButton from '@experiments-labs/rise_ui/src/components/HelpButton/HelpButton.vue'
import RuiToolbar from '@experiments-labs/rise_ui/src/components/Toolbar/Toolbar.vue'

import { isSlotEmpty } from '../../tools/IsSlotEmpty'

/**
 * Use this to display information on a selected Path/Patch/single element of a map
 *
 * @preset default {
 *     "props": { "caption": "A big patch", "surface": "30m<sup>2</sup>" },
 *     "slots": { "default": "<button class=\"rui-button\">Edit</button>\n<button class=\"rui-button rui-button--destructive\">Delete</button>" }
 *   }
 */
export default {
  name: 'GpMapPopup',
  emits: [
    /** Custom event to use in place of `mouseover` on the parent, as using it does nothing */
    'mouse-over',
    /** Custom event to use in place of `mouseleave` on the parent, as using it does nothing */
    'mouse-leave',
    /** User clicked on the "close" button */
    'close',
  ],
  components: { RuiHelpButton, RuiToolbar, RuiButton },
  props: {
    /** Header caption */
    caption: { required: true, type: String },
    /** Optional surface information. HTML allowed, so be careful on what you use */
    surface: { required: false, type: String, default: null },
    /** Help content. Is overridden by `help` slot */
    help: { required: false, type: String, default: null },
  },
  computed: {
    isDefaultSlotEmpty () { return isSlotEmpty(this.$slots.default) },
  },
}
</script>
